<script>
    import { onMount } from "svelte";

    function addZero(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    onMount(() => {
        console.log("onMount");
    });

    let date = new Date();
    $: hour = addZero(date.getHours());
    $: min = addZero(date.getMinutes());
    $: sec = addZero(date.getSeconds());

    onMount(() => {
        const interval = setInterval(() => {
            date = new Date();
        }, 1000);
    });
</script>

<div class="clocka">{hour}:{min}:{sec}</div>

<style>
    div.clocka {
        justify-self: right;
        align-self: center;
        text-align: center;
        font-size: 3em;
        color: rgb(233, 107, 24);
        font-style: bold;
        font-family: "Syne Mono", monospace;
        border-color: rgb(233, 107, 24);
        border-style: dotted;
        padding: 10px 15px;
        text-shadow: 3px 3px 8px #000;
        background-color: #222;
    }
    @media (orientation: portrait) {
        div.clocka {
            justify-self: center;
            margin-bottom: 20px;
        }
    }
</style>
